module.exports = __webpack_public_path__ + "console/img/东骏.11c772c6.jpg";